import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation } from '@tanstack/react-query';
import type {
	LWApiPublicBillingPaypalPaymentCreateParamsRawI,
	LWApiPublicBillingPaypalPaymentCreateResultRawI,
} from '@liquidweb-dev/club-sauce/public/billing/payPal/payment.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

const usePaypalPaymentCreate = () => {
	return useMutation<
		LWApiPublicBillingPaypalPaymentCreateResultRawI,
		ApiErrorI,
		LWApiPublicBillingPaypalPaymentCreateParamsRawI
	>({
		mutationFn: (params) => api.billing.payPal.payment.apiRaw.create(params),
	});
};

export const useOpenPayPalPaymentApprovalUrl = () => {
	const { mutateAsync: createToken, ...rest } = usePaypalPaymentCreate();

	return {
		openPayPalPaymentApprovalUrl: async (
			params: LWApiPublicBillingPaypalPaymentCreateParamsRawI,
		) => {
			try {
				const data = await createToken(params);
				const approvalUrl = data.response.links.find(
					(link) => link.rel === 'approval_url',
				)?.href;

				if (approvalUrl) {
					window.location.assign(approvalUrl);
				}
			} catch {
				toast.danger('Failed to connect to PayPal', {
					description:
						'Please try again or contact support if problem persists',
				});
			}
		},
		...rest,
	};
};

export default usePaypalPaymentCreate;
